import { useCallback, useContext, useEffect, useState } from "react";
import Pager from "components/ui/controls/pager/pager";
import { AppContext } from "components/app/RemExprertProvider";
import DroitsSuccession from "components/app/Simulateurs/Droits Succession/DroitsSuccession";
import { RemoveUnecessaryData } from "components/app/Api/ApiData";

const DroitsSuccessionPage = (props) => {
  const context = useContext(AppContext);
  const [currentPage, setCurrentPage] = useState(1);

  const sendToIframe = useCallback(
    ({ data }) => {
      if (data === "save") {
        let CleanData = RemoveUnecessaryData(context.state);
        delete CleanData.IdUser;
        delete CleanData.IdCabinet;

        let Resultat = {
          LienParenteId: context.state.DroitsSuccessionLienParenteId,
          ActifNet: context.state.DroitsSuccessionActifNet,
          Handicap: context.state.DroitsSuccessionHandicap,
          FSCohabitation: context.state.DroitsSuccessionFSCohabitation,
          FSCelibataire: context.state.DroitsSuccessionFSCelibataire,
          FSInfirmite: context.state.DroitsSuccessionFSInfirmite,
          Representation: context.state.DroitsSuccessionRepresentation,
          NombreRepresentants: context.state.DroitsSuccessionNombreRepresentants,
          AbattementBase: context.state.DroitsSuccessionResultat?.abattementBase,
          AbattementHandicap: context.state.DroitsSuccessionResultat?.abattementHandicap,
          AbattementTotal: context.state.DroitsSuccessionResultat?.abattementTotal,
          BaseTaxable: context.state.DroitsSuccessionResultat?.baseTaxable,
          DroitsTotaux: context.state.DroitsSuccessionResultat?.totalDroits,
          Exonere: context.state.DroitsSuccessionResultat?.exonere,
        };
        let evt = {
          Action: "save",
          DonneesMako: JSON.stringify(CleanData),
          Resultat: Resultat,
        };
        window.top.postMessage(evt, "*");
      }
    },
    [context.state]
  );

  useEffect(() => {
    window.addEventListener("message", sendToIframe);
    return () => window.removeEventListener("message", sendToIframe);
  }, [sendToIframe]);

  const handleMenu = () => {
    let menu = [
      {
        isTitle: true,
        title: "",
      },
      {
        content: <DroitsSuccession accesEtude={props.accesEtude} SetAccessEtude={props?.SetAccessEtude} />,
      },
    ];
    return menu;
  };

  return (
    <Pager
      pages={handleMenu()}
      page={currentPage}
      onPageChange={(page) => {
        setCurrentPage(page);
      }}
    />
  );
};

export default DroitsSuccessionPage;
